import styled from 'styled-components';

export const ModalOverlay = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00000066;
  z-index: 99999;
`;

export const ModalContainer = styled.article`
  position: relative;
  width: 100%;
  min-width: 300px;
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
